var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 3.00293H9.5C10.05 3.00293 10.5 3.45293 10.5 4.00293V20.003C10.5 20.553 10.05 21.003 9.5 21.003H6.5C5.95 21.003 5.5 20.553 5.5 20.003V4.00293C5.5 3.45293 5.95 3.00293 6.5 3.00293ZM14.5 3.00293H17.5C18.05 3.00293 18.5 3.45293 18.5 4.00293V20.003C18.5 20.553 18.05 21.003 17.5 21.003H14.5C13.95 21.003 13.5 20.553 13.5 20.003V4.00293C13.5 3.45293 13.95 3.00293 14.5 3.00293Z",
    fill: "#000F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseAudio);
export default __webpack_public_path__ + "static/media/PauseAudio.2dea04bbfdf43ab8e351b0709103e76c.svg";
export { ForwardRef as ReactComponent };